import { GlobalStyles } from "@mui/material";

/**
 * A pale wash behind a column group and the columns under it, so a reader can tell at a glance
 * which sub-columns belong to which heading. Kept at a few percent: it has to group, not
 * decorate, and the row hover and selection still show through.
 */
export const GROUP_TINT_1 = "dxt-group-tint-1";
export const GROUP_TINT_2 = "dxt-group-tint-2";

const tint = (className: string, color: string) => ({
	[`.ag-header-group-cell.${className}`]: { backgroundColor: color },
	[`.ag-header-cell.${className}`]: { backgroundColor: color },
	[`.ag-cell.${className}`]: { backgroundColor: color },
});

export const ColumnGroupTintStyles = () => (
	<GlobalStyles
		styles={{
			...tint(GROUP_TINT_1, "rgba(63, 81, 181, 0.05)"),
			...tint(GROUP_TINT_2, "rgba(245, 158, 11, 0.07)"),
		}}
	/>
);
